import * as uuid from 'uuid';
import { FormValidatorBuilder } from '../../validator/form-builder/FormValidatorBuilder';
import { IBaseWidget } from '../widgets/IBaseWidget';
import { WidgetMainType, WidgetType } from '../widgets/Widget';
import { IEngineSection } from './IEngineSection';

function uniqueId() {
  return uuid.v4();
}

export class TestEngineSection {
  section: IEngineSection;
  values: any = {};

  constructor(input: Partial<IEngineSection> = {}) {
    this.section = {
      id: uniqueId(),
      ultimaVersione: {
        elementi: {
          type: WidgetType.Root,
          mainType: WidgetMainType.Root,
          children: [],
        },
        visibile: {
          type: 'static',
          value: true,
        },
        compilabile: {
          type: 'static',
          value: true,
        },
      },
      ...input,
    };
  }

  addChildren(children: any[]) {
    this.section.ultimaVersione?.elementi?.children.push(...children);
    return this;
  }

  get schema() {
    return FormValidatorBuilder.buildSections([this.section]).schema;
  }

  setValues(values: any) {
    this.values = {
      [this.section.id]: values,
    };
    return this;
  }
}

export class TestWidget {
  widget: IBaseWidget;

  constructor(
    widget: Partial<IBaseWidget> & { code: string } & Record<string, any>,
  ) {
    this.widget = {
      ...widget,
      id: widget.id ?? uniqueId(),
      type: widget.type ?? WidgetType.Text,
      enabled: {
        type: 'static',
        value: true,
      },
      visible: {
        type: 'static',
        value: true,
      },
    };
  }

  addDirectives(directives: Record<string, any>) {
    this.widget.directives = {
      ...this.widget.directives,
      ...directives,
    };
    return this;
  }

  clone() {
    return new TestWidget(this.widget as any);
  }
}
